module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns_plan_show_bg_04-1197f29aa2d512cbce1876abf505262c.png";